import { useState } from 'react';
import botIcon from '../../../../assets/images/SBX360Bot.png';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../../ui/command';
import { useTranslate } from 'sbx-crm-menu-ui';
import DialogComponent from '../../../shared/DialogComponent';
import ChatContainerMessage from './ChatContainerMessage';

type Props = {
    message: {
        message: string, author: string
    }
};
const ChatBotMessageComponent = ({ message }: Props) => {
    const [openMenu, setOpenMenu] = useState(false);

    const { t } = useTranslate('common');

    return (
        <>
            <ChatContainerMessage host={message.author === 'host'}
                                  messageBody={
                                      <div className="grid grid-cols-[auto_1fr]  gap-1 ">
                                          {message.author === 'bot' && <div className="mt-1">
                                              <img src={botIcon} alt={'SBX360 bot icon'}
                                                   className="w-[32px] h-[32px]" />
                                          </div>}
                                          <div
                                              className={`relative group ${message.author !== 'bot' ? 'bg-white text-black' : 'bg-[#8D35D8] text-white'} rounded-2xl shadow p-3 text-sm`}>
                                              {message.message ?? ''}
                                          </div>
                                      </div>
                                  }
                                  author={''} />

            <DialogComponent headerTitle={''} openDialog={openMenu} setOpenDialog={setOpenMenu} trigger={<></>}>
                {() => {
                    return <Command>
                        <CommandInput
                            placeholder={`${t('type_a_command_or_search') ?? 'Type a command or search...'}`} />
                        <CommandList>
                            <CommandEmpty>{t('no_results')}</CommandEmpty>
                            <CommandGroup heading={t('actions')}>
                                <CommandItem onSelect={() => {
                                    setOpenMenu(false);
                                }}>
                                    {t('answer_to_the_client') ?? 'Responder al cliente'}
                                </CommandItem>

                            </CommandGroup>
                        </CommandList>
                    </Command>;
                }}
            </DialogComponent>
        </>
    );
};

export default ChatBotMessageComponent;